import React from 'react';
import { CFooter } from '@coreui/react-pro';

const SystemAdminFooter = () => {
     return <CFooter position="fixed" className="footer-admin"></CFooter>;
};

export default SystemAdminFooter;
